export enum ItemScenarios {
  Empty = 'empty',
  New = 'new',
  Copy = 'copy',
  Existing = 'existing'
}
